import { VOICE_BAR_RESERVE } from '#features/media-window/model';
import { mobileScreen } from './mobileNavigation';

/** Высота общей шапки приложения на телефоне и десктопе (`Header`: `h="60px"`). */
export const APP_HEADER_HEIGHT = '60px';

/**
 * Место внизу страницы на телефоне под нижнюю навигацию и полосу разговора.
 *
 * Именно `max`, а не сумма: полоса стоит НАД навигацией и в занятое ею место навигацию уже
 * включает. Пока навигация спрятана (клавиатура, экран без неё), остаётся только полоса.
 */
export const phoneBottomReserve = (bottomNavAway: boolean): string =>
  bottomNavAway
    ? VOICE_BAR_RESERVE
    : `max(calc(env(safe-area-inset-bottom) + var(--bottom-nav-height, 60px) + 16px), ${VOICE_BAR_RESERVE})`;

/**
 * Высота экрана, который обязан занять ровно окно: шапка сверху, место под навигацию снизу,
 * всё между ними - содержимое, прокручивающееся внутри себя.
 */
export const fitWindowHeight = (bottomReserve: string): string =>
  `calc(100dvh - ${APP_HEADER_HEIGHT} - ${bottomReserve})`;

/**
 * Экран списка переписок, а не открытый разговор. Список занимает ровно окно телефона и подвала
 * не несёт (смоук FIND-6: страница выходила за окно на 175 px - подвал 121 и место под навигацию).
 * Открытый разговор (`/chats/$chatId` и `?peerUserId=`) сюда не входит: он живёт по своим правилам.
 */
export const isChatListScreen = (pathname: string, isChatThread: boolean): boolean => {
  const screen = mobileScreen(pathname);
  return screen.kind === 'root' && screen.root === 'chats' && !isChatThread;
};
